/**
 * What kind of device a browser session is running on, from the user agent. Web only in
 * practice (native builds know their platform from `Platform.OS`); safe to import anywhere.
 */
export type BrowserPlatform = 'android' | 'ios' | 'desktop';

export const detectBrowserPlatform = (): BrowserPlatform => {
	if (typeof navigator === 'undefined') return 'desktop';
	const ua = navigator.userAgent || '';
	if (/android/i.test(ua)) return 'android';
	// iPadOS reports itself as a Mac; touch support gives it away.
	if (/iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1)) {
		return 'ios';
	}
	return 'desktop';
};

/**
 * True inside an app's embedded browser (Facebook, Instagram, Messenger, TikTok, ...) or a
 * bare WebView, where there is no share sheet, no "Add to Home Screen" and no install prompt.
 */
export const isInAppBrowser = (): boolean => {
	if (typeof navigator === 'undefined') return false;
	const ua = navigator.userAgent || '';
	if (/FBAN|FBAV|FB_IAB|Instagram|Messenger|Line\/|Twitter|TikTok|musical_ly|Snapchat/i.test(ua)) {
		return true;
	}
	// Android WebView marks itself with "; wv)"; an iOS WebView is a Mobile UA without Safari.
	if (/; wv\)/.test(ua)) return true;
	if (/iphone|ipad|ipod/i.test(ua) && !/Safari\//i.test(ua)) return true;
	return false;
};
